/**
 * Config
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

// -------
// Private
// -------

// Icons
const icons = {
	calendarCheck : '<i aria-hidden="true" class="fa-regular fa-calendar-check"></i>',
	clock         : '<i aria-hidden="true" class="fa-regular fa-clock"></i>',
	close         : '<i aria-hidden="true" class="fa-regular fa-times"></i>',
	next          : '<i aria-hidden="true" class="fa-regular fa-chevron-right"></i>',
	prev          : '<i aria-hidden="true" class="fa-regular fa-chevron-left"></i>',
	remove        : '<i aria-hidden="true" class="fa-regular fa-trash-can"></i>'
};

// ------
// Public
// ------

// Export
export default {
	icons
};
